import axios from '@axios'

export default {
  getDirections(page, field) {
    return axios.post(`platform/directions/list?page=${page}`, field)
  },

  getDirection(id) {
    return axios.get(`platform/directions/${id}`)
  },

  getDistance(id) {
    return axios.get(`platform/directions/distance/${id}`)
  },

  getGMapKey() {
    return axios.get('platform/directions/gmap/key')
  },

  updateDirection(direction) {
    return axios.post(`platform/directions/${direction.id}`, direction)
  },
}
